import React, { useEffect, useState, ChangeEvent, useRef } from 'react';
import moment from 'moment';
import './PetInsuranceForm.scss';
import { Insurance } from '..';
type Props = {
  insurance?: Insurance;
};

import { ReactComponent as PdfIcon } from '@/assets/img/pdf-icon.svg';
import Utils from '@/utils/util';

export const PetInsuranceForm = ({ insurance }: Props) => {
  return (
    <div className="insurance-form tab-content petsked-form">
      <div
        className={`insurance-top-section ${
          insurance?.insuranceCopy ? 'submitted' : 'notsubmitted'
        }`}
      >
        <span className={`status ${insurance?.insuranceCopy ? 'submitted' : 'notsubmited'}`}>
          {insurance?.insuranceCopy ? 'Submitted' : 'Not Submitted'}
        </span>
      </div>

      {insurance?.insuranceCopy && (
        <>
          <div className="cards">
            <div className="insurance-card">
              <div className="left-details">
                <PdfIcon />
                <div className="file-details">
                  <p>
                    <a href={insurance.insuranceCopy} target="_blank" rel="noreferrer">
                      {insurance.fileName ? insurance.fileName : 'Insurance Document'}
                    </a>
                  </p>
                  <p>{Utils.getFileSize(insurance.fileSize)}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-field">
            <label className="form-label">Insurance details</label>
            <div className="split full">
              <span>
                <input type="text" placeholder="nil" value={insurance.insuranceName} disabled />
              </span>
              <span className="datepicker-container">
                <input
                  readOnly
                  disabled
                  type="text"
                  placeholder="Nil"
                  value={
                    insurance?.insuranceExpiry
                      ? moment(insurance.insuranceExpiry).format('DD-MMM-YYYY')
                      : ''
                  }
                  className="cust-input-mobile" // a styling class
                />
              </span>
            </div>
            <label className="form-label">Notes</label>

            <textarea
              rows={4}
              placeholder="Add note"
              value={insurance.insuranceInformation}
              disabled
            />
          </div>
        </>
      )}
    </div>
  );
};
